// Mock data for subjects - SAT V4 Zone
import type { Subject, OptionBlock } from '../../types';

export const mockSubjects: Subject[] = [
  {
    id: 'subj-eng',
    name: 'English',
    code: 'ENG',
    department: 'English',
    color: '#4CAF50',
    yearGroups: [7, 8, 9, 10, 11],
    periodsPerWeek: { 7: 5, 8: 5, 9: 5, 10: 5, 11: 5 },
    requiredEquipment: [],
    preferredRoomTypes: ['classroom'],
    isCore: true,
  },
  {
    id: 'subj-mat',
    name: 'Mathematics',
    code: 'MAT',
    department: 'Mathematics',
    color: '#2196F3',
    yearGroups: [7, 8, 9, 10, 11],
    periodsPerWeek: { 7: 5, 8: 5, 9: 5, 10: 5, 11: 5 },
    requiredEquipment: ['calculators'],
    preferredRoomTypes: ['classroom'],
    isCore: true,
  },
  {
    id: 'subj-sci',
    name: 'Science',
    code: 'SCI',
    department: 'Science',
    color: '#9C27B0',
    yearGroups: [7, 8, 9],
    periodsPerWeek: { 7: 4, 8: 4, 9: 4 },
    requiredEquipment: ['science_equipment'],
    preferredRoomTypes: ['lab'],
    isCore: true,
  },
  {
    id: 'subj-phy',
    name: 'Physics',
    code: 'PHY',
    department: 'Science',
    color: '#673AB7',
    yearGroups: [10, 11],
    periodsPerWeek: { 10: 3, 11: 3 },
    requiredEquipment: ['science_equipment'],
    preferredRoomTypes: ['lab'],
    isCore: false,
    optionBlockId: 'opt-a',
  },
  {
    id: 'subj-che',
    name: 'Chemistry',
    code: 'CHE',
    department: 'Science',
    color: '#E91E63',
    yearGroups: [10, 11],
    periodsPerWeek: { 10: 3, 11: 3 },
    requiredEquipment: ['science_equipment', 'fume_cupboard'],
    preferredRoomTypes: ['lab'],
    isCore: false,
    optionBlockId: 'opt-a',
  },
  {
    id: 'subj-bio',
    name: 'Biology',
    code: 'BIO',
    department: 'Science',
    color: '#8BC34A',
    yearGroups: [10, 11],
    periodsPerWeek: { 10: 3, 11: 3 },
    requiredEquipment: ['science_equipment', 'microscopes'],
    preferredRoomTypes: ['lab'],
    isCore: false,
    optionBlockId: 'opt-a',
  },
  {
    id: 'subj-his',
    name: 'History',
    code: 'HIS',
    department: 'Humanities',
    color: '#795548',
    yearGroups: [7, 8, 9, 10, 11],
    periodsPerWeek: { 7: 2, 8: 2, 9: 2, 10: 3, 11: 3 },
    requiredEquipment: [],
    preferredRoomTypes: ['classroom'],
    isCore: true,
  },
  {
    id: 'subj-geo',
    name: 'Geography',
    code: 'GEO',
    department: 'Humanities',
    color: '#009688',
    yearGroups: [7, 8, 9, 10, 11],
    periodsPerWeek: { 7: 2, 8: 2, 9: 2, 10: 3, 11: 3 },
    requiredEquipment: [],
    preferredRoomTypes: ['classroom'],
    isCore: true,
  },
  {
    id: 'subj-fre',
    name: 'French',
    code: 'FRE',
    department: 'Modern Foreign Languages',
    color: '#3F51B5',
    yearGroups: [7, 8, 9, 10, 11],
    periodsPerWeek: { 7: 3, 8: 3, 9: 3, 10: 3, 11: 3 },
    requiredEquipment: ['audio_equipment'],
    preferredRoomTypes: ['classroom'],
    isCore: true,
  },
  {
    id: 'subj-spa',
    name: 'Spanish',
    code: 'SPA',
    department: 'Modern Foreign Languages',
    color: '#FF5722',
    yearGroups: [7, 8, 9, 10, 11],
    periodsPerWeek: { 7: 2, 8: 2, 9: 2, 10: 3, 11: 3 },
    requiredEquipment: ['audio_equipment'],
    preferredRoomTypes: ['classroom'],
    isCore: false,
    optionBlockId: 'opt-b',
  },
  {
    id: 'subj-art',
    name: 'Art & Design',
    code: 'ART',
    department: 'Arts',
    color: '#F44336',
    yearGroups: [7, 8, 9, 10, 11],
    periodsPerWeek: { 7: 2, 8: 2, 9: 2, 10: 3, 11: 3 },
    requiredEquipment: ['art_supplies'],
    preferredRoomTypes: ['studio'],
    isCore: false,
    optionBlockId: 'opt-b',
  },
  {
    id: 'subj-mus',
    name: 'Music',
    code: 'MUS',
    department: 'Arts',
    color: '#FF9800',
    yearGroups: [7, 8, 9, 10, 11],
    periodsPerWeek: { 7: 2, 8: 2, 9: 1, 10: 3, 11: 3 },
    requiredEquipment: ['instruments', 'audio_equipment'],
    preferredRoomTypes: ['studio'],
    isCore: false,
    optionBlockId: 'opt-c',
  },
  {
    id: 'subj-dra',
    name: 'Drama',
    code: 'DRA',
    department: 'Arts',
    color: '#FFEB3B',
    yearGroups: [7, 8, 9, 10, 11],
    periodsPerWeek: { 7: 1, 8: 1, 9: 1, 10: 3, 11: 3 },
    requiredEquipment: [],
    preferredRoomTypes: ['hall', 'studio'],
    isCore: false,
    optionBlockId: 'opt-c',
  },
  {
    id: 'subj-pe',
    name: 'Physical Education',
    code: 'PE',
    department: 'PE',
    color: '#00BCD4',
    yearGroups: [7, 8, 9, 10, 11],
    periodsPerWeek: { 7: 2, 8: 2, 9: 2, 10: 2, 11: 2 },
    requiredEquipment: ['sports_equipment'],
    preferredRoomTypes: ['gym', 'hall'],
    isCore: true,
  },
  {
    id: 'subj-dt',
    name: 'Design & Technology',
    code: 'DT',
    department: 'Technology',
    color: '#607D8B',
    yearGroups: [7, 8, 9, 10, 11],
    periodsPerWeek: { 7: 2, 8: 2, 9: 2, 10: 3, 11: 3 },
    requiredEquipment: ['workshop_tools'],
    preferredRoomTypes: ['workshop'],
    isCore: false,
    optionBlockId: 'opt-c',
  },
  {
    id: 'subj-ict',
    name: 'Computer Science',
    code: 'ICT',
    department: 'Computing',
    color: '#00ACC1',
    yearGroups: [7, 8, 9, 10, 11],
    periodsPerWeek: { 7: 2, 8: 2, 9: 2, 10: 3, 11: 3 },
    requiredEquipment: ['computers'],
    preferredRoomTypes: ['computer_room'],
    isCore: false,
    optionBlockId: 'opt-b',
  },
  {
    id: 'subj-rs',
    name: 'Religious Studies',
    code: 'RS',
    department: 'Humanities',
    color: '#5D4037',
    yearGroups: [7, 8, 9, 10, 11],
    periodsPerWeek: { 7: 1, 8: 1, 9: 1, 10: 2, 11: 2 },
    requiredEquipment: [],
    preferredRoomTypes: ['classroom'],
    isCore: true,
  },
];

export const mockOptionBlocks: OptionBlock[] = [
  {
    id: 'opt-a',
    name: 'Option Block A',
    yearGroup: 10,
    subjects: ['subj-phy', 'subj-che', 'subj-bio'],
    maxSelections: 1,
    periodSlot: 'Monday P3-P4',
  },
  {
    id: 'opt-b',
    name: 'Option Block B',
    yearGroup: 10,
    subjects: ['subj-spa', 'subj-art', 'subj-ict'],
    maxSelections: 1,
    periodSlot: 'Wednesday P3-P4',
  },
  {
    id: 'opt-c',
    name: 'Option Block C',
    yearGroup: 10,
    subjects: ['subj-mus', 'subj-dra', 'subj-dt'],
    maxSelections: 1,
    periodSlot: 'Friday P3-P4',
  },
];

export default mockSubjects;

